import React from 'react'

const FixedTopBar = () => {
  return (
    <div className='fixed-top bg-light px-1 py-2 d-flex flex-row-reverse align-items-center gap-3 gap-md-5' style={{ zIndex: 1000 }}>
        <p className='m-0 fw-normal fw-md-bold'><span><i className="bi bi-envelope fs-6 text-primary"></i></span>  technoaarv@gmail.com</p>
        <p className='m-0 fw-normal fw-md-bold'><span><i className="bi bi-telephone fs-6 text-primary" ></i></span>  +91 9130093700</p>
    </div>
  )
}

export default FixedTopBar